import { TimeValidationError } from '@mui/x-date-pickers/models';

export const parseAnchorTime = (time: string | null | undefined): Date | null => {
  const match = time?.match(/^([01]\d|2[0-3]):([0-5]\d)$/);

  return match ? new Date(2000, 0, 1, Number(match[1]), Number(match[2])) : null;
};

export const formatAnchorTime = (date: Date | null, error: TimeValidationError = null): string => {
  if (!date || !Number.isFinite(date.getTime()) || error) {
    return '';
  }

  return `${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}`;
};
